import { BlogPost } from "@/data/blogPosts";
import { Link } from "react-router-dom";
import { getPostKicker } from "@/utils/postKicker";

interface BlogCardProps {
  post: BlogPost;
  aiReason?: string;
}

const BlogCard = ({ post, aiReason }: BlogCardProps) => {
  return (
    <Link to={`/blog/${post.slug}`} className="group block h-full">
      <article className="h-full flex flex-col">
        {/* Image */}
        <div className="overflow-hidden rounded-xl">
          <div className="aspect-video w-full">
            <img
              src={post.image}
              alt={post.title}
              className="object-cover w-full h-full grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
            />
          </div>
        </div>

        {/* Content */}
        <div className="pt-4 flex-1 flex flex-col space-y-2.5">
          <p className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground/40">
            {getPostKicker(post)} · {new Date(post.date).toLocaleDateString("es-ES", {
              day: "numeric",
              month: "short",
            })}
          </p>

          <h3 className="text-base md:text-lg font-normal text-foreground leading-snug line-clamp-3 group-hover:text-primary transition-colors duration-500">
            {post.title}
          </h3>

          <p className="text-xs text-muted-foreground/50 font-light leading-relaxed line-clamp-2 flex-1">
            {post.description}
          </p>

          {aiReason && (
            <p className="text-[11px] text-muted-foreground/40 leading-relaxed line-clamp-2 pt-2 border-t border-border/20">
              <span className="text-primary/50">IA →</span> {aiReason}
            </p>
          )}
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
